const topics = [
  {
    title: "Place Value",
    slug: "placevalue",
    standardNumber: "4.1",
    description: "Number and Operations in Base Ten",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fplacevalue2025video.mp4?alt=media&token=3f9c9c42-f584-47e7-bcdd-b83c8aa7fbbc",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fplacevalue2025song.mp3?alt=media&token=847038d3-72ea-4c54-9645-9ef01971073e",
    lyrics: ["(intro)",
"Place value.",
"Place value.",

"(chorus)",
"As we go to the left,",
"each place value goes up 10 times.",
"As we go to the left,",
"each place value goes up 10 times.",

"(verse)",
"In our number system",
"the value depends on the place or position",
"of a number, of a number.",
"In our number system",
"the value depends on the place or position",
"of a number, of a number.",

"Ones place.",
"Tens place.",
"Hundreds place.",
"Thousands place.",
"Ten thousands place.",
"Hundred thousands place.",
"Millions place.",

"Ones place.",
"Tens place.",
"Hundreds place.",
"Thousands place.",
"Ten thousands place.",
"Hundred thousands place.",
"Millions place.",

"(chorus)",
"As we go to the left,",
"each place value goes up 10 times.",
"As we go to the left,",
"each place value goes up 10 times.",

"(outro)",
"Place value.",
"Place value.",

"© Smart Board Learning, LLC. All rights reserved.",]
  },
  {
    title: "Compare Fractions",
    slug: "comparefractions",
    standardNumber: "4.2",
    description: "Number and Operations – Fractions",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fcomparefractions.mp4?alt=media&token=936902a3-e5e0-4efa-8f22-042d0c9125b5",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fcomparefractionssong.mp3?alt=media&token=09a3b0f5-abbd-4861-94e3-516db9b3cb2a",
    lyrics: ["(Chorus)",
"We can compare fractions,",
"with common denominators, with common denominators.",
"We can compare fractions,",
"with common denominators, with common denominators.",

"(Verse)",
"If the fractions have different denominators,",
"we must make the denominators the same.",
"Then compare the numerators,",
"to tell which one is greater,",
"or which one is less than or equal to.",

"(Chorus)",
"We can compare fractions,",
"with common denominators, with common denominators.",
"We can compare fractions,",
"with common denominators, with common denominators.",

"© Smart Board Learning, LLC. All rights reserved.",]
  },
  {
    title: "Add & Subtract Fractions",
    slug: "addandsubtractfractions",
    standardNumber: "4.5",
    description: "Number and Operations – Fractions",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Faddandsubtractfractions2025video.mp4?alt=media&token=0b575bc0-27e3-417a-808e-fbe662913ce3",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Faddandsubtractfractions2025song.mp3?alt=media&token=fceb51a6-d168-46a7-9f3c-eaf44f49ab62",
    lyrics: ["(chorus)",
"All denominators must be the same, all denominators must be the same,",
"to add or subtract fractions, to add or subtract fractions.",
"All denominators must be the same, all denominators must be the same,",
"to add or subtract fractions, to add or subtract fractions.",

"(verse1)",
"Unlike fractions have different denominators.",
"Let's make them the same denominators.",
"First, you write out all their multiples.",
"Then, you pick out the least common multiples.",
"Change all denominators to the least common multiple.",
"Then, whatever you multiply the bottom number by,",
"you must multiply the top number by too.",

"(chorus)",
"All denominators must be the same, all denominators must be the same,",
"to add or subtract fractions, to add or subtract fractions.",
"All denominators must be the same, all denominators must be the same,",
"to add or subtract fractions, to add or subtract fractions.",

"(verse2)",
"Now, take your new fractions with the same denominators,",
"And you add or subtract your numerators.",
"Your denominator will just move on over because it stays the same.",
"Then reduce to simplest form, then reduce to simplest form.",

"© Smart Board Learning, LLC. All rights reserved.",]
  },
  {
    title: "Elapsed Time",
    slug: "elapsedtime",
    standardNumber: "4.9",
    description: "Measurement and Data",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Felapsedtime2025video.mp4?alt=media&token=86c77363-d4d5-44b6-94c4-d7b8e567bb7f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Felapsedtime2025song.mp3?alt=media&token=1b888c34-4ec0-453d-8636-8d7596338d6c",
    lyrics: ["(chorus)",
"Elapsed time is the time in between two given times.",
"Elapsed time is the time in between two given times.",
"Elapsed time is the time in between two given times.",
"Elapsed time is the time in between two given times.",

"(verse)",
"If, school started at 2 o’clock,",
"and school ended at 4 o’clock,",
"then, 2 hours have elapsed.",
"If, work started at 4 o’clock,",
"and work ended at 8 o’clock,",
"then, 4 hours have elapsed.",
"If, school started at 2 o’clock,",
"and school ended at 4 o’clock,",
"then, 2 hours have elapsed.",
"If, work started at 4 o’clock,",
"and work ended at 8 o’clock,",
"then, 4 hours have elapsed.",

"(chorus)",
"Elapsed time is the time in between two given times.",
"Elapsed time is the time in between two given times.",

"© Smart Board Learning, LLC. All rights reserved.",]
  },
  {
    title: "Angles",
    slug: "angles",
    standardNumber: "4.10",
    description: "Measurement and Data",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fangles2024.mp4?alt=media&token=3235dd9f-bb5f-426c-ac5a-b9819abdeab1",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fangles2025song.mp3?alt=media&token=8da3d2f4-a227-4443-b412-1a5a1e4237be",
    lyrics: ["(chorus)",
"We can use a protractor to measure angles.",
"We can use a protractor to measure angles.",
"When you rotate two rays you get angles.",
"When you rotate two rays you get angles.",
"All angles have a vertex, vertex.",
"All angles have a vertex, vertex.",

"(verse)",
"Right angle looks like an L and measures 90 degrees.",
"Right angle looks like an L and measures 90 degrees.",
"Acute angles are less than 90 degrees.",
"Acute angles are less than 90 degrees.",
"Obtuse angles are more than 90 degrees but less than 180.",
"Obtuse angles are more than 90 degrees but less than 180.",

"(chorus)",
"We can use a protractor to measure angles.",
"We can use a protractor to measure angles.",
"When you rotate two rays you get angles.",
"When you rotate two rays you get angles.",
"All angles have a vertex, vertex.",
"All angles have a vertex, vertex.",

"© Smart Board Learning, LLC. All rights reserved.",]
  },
  {
    title: "Lines",
    slug: "lines",
    standardNumber: "4.10",
    description: "Geometry",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Flinesvideo2024.mp4?alt=media&token=bbbc6959-b2aa-4699-b65f-5d56f161285f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Flinessong.mp3?alt=media&token=ebb68a24-e85f-48be-8e21-0d7abbb713e2",
    lyrics: ["(chorus)",
"We line it up and then we break it down",
"We line it up and then we break it down",
"We line it up and then we break it down",
"We line it up and then we break it down",

"(verse)",
"Line:",
"A straight path in a plane extending in both directions.",
"Line:",
"A straight path in a plane extending in both directions.",
"Perpendicular Lines:",
"Two lines that intersect to form right angles.",
"Perpendicular Lines:",
"Two lines that intersect to form right angles.",
"Intersecting Lines:",
"Lines that cross each other at exactly one point.",
"Intersecting Lines:",
"Lines that cross each other at exactly one point.",
"Parallel Lines:",
"Lines in a plane that do not intersect.",
"Parallel Lines:",
"Lines in a plane that do not intersect.",
"Ray:",
"Starts at an endpoint while the other side goes on forever.",
"Ray:",
"Starts at an endpoint while the other side goes on forever.",
"Line Segment:",
"Part of a line that has two end points.",
"Line Segment:",
"Part of a line that has two end points.",

"(chorus)",
"We line it up and then we break it down",
"We line it up and then we break it down",
"We line it up and then we break it down",
"We line it up and then we break it down",

"© Smart Board Learning, LLC. All rights reserved.",]
  },
  {
    title: "Quadrilaterals",
    slug: "quadrilaterals",
    standardNumber: "NC.4.12",
    description: "Geometry",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fquadrilaterals2025video.mp4?alt=media&token=57b6de94-4476-44aa-ab80-267919f7223b",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fquarilaterals2025song.mp3?alt=media&token=a6699325-e75b-45d0-96c5-9cd7855e1d32",
    lyrics: ["(chorus)",
"Quadrilaterals are four sided shapes, four sides,",
"quadrilaterals are four sided shapes, four sides.",
"(verse)",
"A quadrilateral is a four sided polygon.",
"A rectangle is a four sided quadrilateral,",
"with four right angles.",
"A rectangle is a four sided quadrilateral,",
"opposite sides are equal.",
"A square is a four sided quadrilateral,",
"all four sides are equal.",
"A parallelogram is a four sided quadrilateral,",
"with two pair of parallel sides.",
"(chorus)",
"Quadrilaterals are four sided shapes, four sides,",
"quadrilaterals are four sided shapes, four sides.",

"© Smart Board Learning, LLC. All rights reserved.",]
  },
  {
    title: "Triangles",
    slug: "triangles",
    standardNumber: "4.12",
    description: "Geometry",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Ftriangles2025video.mp4?alt=media&token=b3ca5c4f-ae63-49a1-b942-44e473c1b83c",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ftriangles2025song.mp3?alt=media&token=9be3e0b3-f67d-41d0-86cc-cd3db42a4bbb",
    lyrics: ["(chorus)",
"Triangles, 3 sides, 3 angles.",
"Triangles, 3 sides, 3 angles.",
"Triangles, 3 sides, 3 angles.",
"Triangle is a polygon, triangle is a polygon.",

"(verse)",
"An acute triangle has 3 angles",
"that are less than 90 degrees.",
"An obtuse triangle has 3 angles",
"but 1 angle is more than 90 degrees.",
"A right triangle has 3 angles",
"but 1 angle equals 90 degrees.",
"An equilateral triangle has 3 sides,",
"and all 3 sides are equal.",
"Isosceles triangle has 3 sides,",
"but only 2 of those sides are equal.",
"A scalene triangle has 3 sides.",
"All 3 sides have different sizes.",

"(chorus)",
"Triangles, 3 sides, 3 angles.",
"Triangles, 3 sides, 3 angles.",
"Triangles, 3 sides, 3 angles.",
"Triangle is a polygon, triangle is a polygon.",

"© Smart Board Learning, LLC. All rights reserved.",]
  },
  {
    title: "2 Times Table",
    slug: "2timestable",
    standardNumber: "TT",
    description: "Multiplication Facts",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2F2timetablesrock2024video.mp4?alt=media&token=8ecdf9fc-713f-43cc-a87d-34bac7fee19e",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2F2timestablerock2025song.mp3?alt=media&token=4d84d534-0f6b-4245-8265-a5f6465e8799",
    lyrics: ["(Chorus)",
"Here’s the 2 times tables now, get our 2 times tables down.",
"Hey, you can do it, hey, you can do it, hey, you can do it, hey, hey, hey, hey.",
"Here’s the 2 times tables now, get our 2 times tables down.",
"Hey, you can do it, hey, you can do it, hey, you can do it, hey, hey, hey, hey.",

"(Verse)",
"2x1 is 2 (2).",
"2x2 is 4 (4).",
"2x3 is 6 (6).",
"2x4 is 8 (8).",
"2x5 is 10 (10).",
"2x6 is 12 (12).",
"2x7 is 14 (14).",
"2x8 is 16 (16).",
"2x9 is 18 (18).",
"2x10 is 20 (20).",
"2x11 is 22 (22).",
"2x12 is 24 (24).",

"(Chorus)",
"Here’s the 2 times tables now, get our 2 times tables down.",
"Hey, you can do it, hey, you can do it, hey, you can do it, hey, hey, hey, hey.",
"Here’s the 2 times tables now, get our 2 times tables down.",
"Hey, you can do it, hey, you can do it, hey, you can do it, hey, hey, hey, hey.",

"(Bridge)",
"2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24.",
"2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24.",
"2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24.",
"2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24.",
]
  },
  {
    title: "3 Times Table",
    slug: "3timestable",
    standardNumber: "TT",
    description: "Multiplication Facts",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2F3timetablesrock2024rock.mp4?alt=media&token=35e4f45b-eac3-4a23-bf2d-31fef4b7a0d5",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2F3timestablerock2025song.mp3?alt=media&token=a75df1ee-f325-47f6-8ebb-a113de0d46bd",
    lyrics: ["(Chorus)",
"Let’s do our 3 times tables, let’s do our 3 times tables.",
"Rock these tables, rock these tables.",
"Let’s do our 3 times tables, let’s do our 3 times tables.",
"Rock these tables, rock these tables.",

"(Bridge)",
"3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36.",
"3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36.",
"3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36.",

"(Verse)",
"3x1 = 3.",
"3x2 = 6.",
"3x3 = 9.",
"It’ll be 9 all the time.",
"3x4 = 12.",
"3x5 = 15.",
"3x6 = 18.",
"Keep fresh kicks on and they stay clean.",
"3x7 = 21.",
"3x8 = 24.",
"3x9 = 27.",
"Make the world feel like heaven.",
"3x10 = 30.",
"3x11 = 33.",
"3x12 = 36.",
"Times tables put me in the mix.",

"(Chorus)",
"Let’s do our 3 times tables, let’s do our 3 times tables.",
"Rock these tables, rock these tables.",
"Let’s do our 3 times tables, let’s do our 3 times tables.",
"Rock these tables, rock these tables.",

"(Bridge)",
"3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36.",
"3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36.",
"3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36.",
]
  },
  {
    title: "4 Times Table",
    slug: "4timestable",
    standardNumber: "TT",
    description: "Multiplication Facts",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2F4timetablesrock2025video.mp4?alt=media&token=23b1c7e2-3247-4b9e-991f-ba5e3adfc87b",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2F4timestablerock2025song.mp3?alt=media&token=f49c9276-8780-4bda-bbd0-52958cf74aef",
    lyrics: ["(Chorus)",
"4 is a beautiful number when you multiply.",
"4 is a beautiful number when you multiply.",
"4 is a beautiful number when you multiply.",
"When you multiply, when you multiply.",

"(Verse 1)",
"Let’s spit it raw; 4x1 is 4.",
"But get it straight; 4x2 is 8.",
"Not hard to tell; 4x3 is 12.",
"Know what I mean; 4x4 is 16.",
"There’s nothing funny; 4x5 is 20.",
"It’s time to score; 4x6 is 24.",
"Put on your skates; 4x7 is 28.",
"You know what to do; 4x8 is 32.",

"(Chorus)",
"4 is a beautiful number when you multiply.",
"4 is a beautiful number when you multiply.",
"4 is a beautiful number when you multiply.",
"When you multiply, when you multiply.",

"(Verse 2)",
"Don’t throw no fits; 4x9 is 36.",
"My teacher taught me; 4x10 is 40.",
"I want some more; 4x11 is 44.",
"Get it straight; 4x12 is 48.",

"(Bridge)",
"4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48.",
"Let’s count by 4’s.",
]
  },
  {
    title: "5 Times Table",
    slug: "5timestable",
    standardNumber: "TT",
    description: "Multiplication Facts",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2F5timetablesrock2025video.mp4?alt=media&token=9620f587-7d3b-4485-a92c-d430c10fd080",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2F5timestablerock2025song.mp3?alt=media&token=e2986676-bf46-4c6b-bdb7-5fbe009e27d3",
    lyrics: ["(Chorus)",
"This is it with the 5 times tables we grow.",
"The 5 times tables we know.",
"The 5 times tables I know you know for sure.",
"5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60.",
"Yeah, let’s count by 5’s, yeah, let’s count by 5’s.",

"(Verse 1)",
"5x1 = 5.",
"5x2 = 10.",
"5x3 = 15.",
"5x4 = 20.",
"5x5 = 25.",
"5x6 = 30.",
"5x7 = 35.",
"5x8 = 40.",

"(Chorus)",
"This is it with the 5 times tables we grow.",
"The 5 times tables we know.",
"The 5 times tables I know you know for sure.",
"5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60.",
"Yeah, let’s count by 5’s, yeah, let’s count by 5’s.",

"(Verse 2)",
"5x9 = 45.",
"5x10 = 50.",
"5x11 = 55.",
"5x12 = 60.",

"(Bridge)",
"5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60.",
"Yeah, let’s count by 5’s, yeah, let’s count by 5’s.",
]
  },
  {
    title: "6 Times Table",
    slug: "6timestable",
    standardNumber: "TT",
    description: "Multiplication Facts",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2F6timetablesrock2024video.mp4?alt=media&token=ced83768-13bd-4bf3-8399-2b38bc7ef928",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2F6timestablerock2025song.mp3?alt=media&token=2e0ae3d0-258f-4a57-9a62-145a999e6873",
    lyrics: ["(Bridge)",
"6, 12, 18, 24, 30, 36, 42, 48, 54, 60.",
"6, 12, 18, 24, 30, 36, 42, 48, 54, 60.",

"(Chorus)",
"6 times tables, 6 times tables.",
"6 times tables, 6 times tables.",

"(Verse)",
"6x1 is 6; we’re on a roll.",
"6x2 is 12; this we know.",
"6x3 is 18; get it right.",
"6x4 is 24; aim for the sky.",
"6x5 is 30; the right turns.",
"6x6 is 36; we learn.",
"6x7 is 42; right again.",
"6x8 is 48; my writer’s pen.",
"6x9 is 54; stay on point.",
"6x10 is 60; this is my joint.",

"(Chorus)",
"6 times tables, 6 times tables.",
"6 times tables, 6 times tables.",

"(Bridge)",
"6, 12, 18, 24, 30, 36, 42, 48, 54, 60.",
"6, 12, 18, 24, 30, 36, 42, 48, 54, 60.",
"6, 12, 18, 24, 30, 36, 42, 48, 54, 60.",
"6, 12, 18, 24, 30, 36, 42, 48, 54, 60.",
]
  },
  {
    title: "7 Times Table",
    slug: "7timestable",
    standardNumber: "TT",
    description: "Multiplication Facts",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2F7timetablesrock2024video.mp4?alt=media&token=08a55898-8f94-4fca-83a7-05b1ddd3cebe",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2F7timestablerock2025song.mp3?alt=media&token=01a80126-5431-4d02-a5e8-07ead35cb4bf",
    lyrics: ["(Chorus)",
"7 times tables, let’s do the 7 times tables.",
"7 times tables, let’s do the 7 times tables.",

"(Verse)",
"7x1 = 7.",
"7x2 = 14.",
"7x3 = 21.",
"7x4 = 28.",
"7x5 = 35.",
"7x6 = 42.",
"7x7 = 49.",
"7x8 = 56.",
"7x9 = 63.",
"7x10 = 70.",
"7x11 = 77.",
"7x12 = 84.",

"(Chorus)",
"7 times tables, let’s do the 7 times tables.",
"7 times tables, let’s do the 7 times tables.",
"7 times tables, let’s do the 7 times tables.",
"7 times tables, let’s do the 7 times tables.",

"(Bridge)",
"7, 14, 21, 28, 35, 42, 49, 56, 63, 70, 77, 84.",
"7, 14, 21, 28, 35, 42, 49, 56, 63, 70, 77, 84.",
]
  },
  {
    title: "8 Times Table",
    slug: "8timestable",
    standardNumber: "TT",
    description: "Multiplication Facts",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2F8timetablesrock2024video.mp4?alt=media&token=e313f375-1f53-428c-9e96-2d719da07b3c",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2F8timestablerock2025song.mp3?alt=media&token=839cae06-b44a-4bb2-9e8a-387eb1ee499c",
    lyrics: ["(Chorus)",
"8 times tables, 8 times tables, 8 times tables.",
"8 times tables, 8 times tables, 8 times tables, go, go, go, go.",

"8x1 is 8. Let's go.",
"8x2 is 16. Let's go.",
"8x3 is 24. Let's go, go, go, go, go.",
"8x4 is 32. Let's go.",
"8x5 is 40. Let's go.",
"8x6 is 48. Let's go, go, go, go, go.",
"8x7 is 56. Let's go.",
"8x8 is 64. Let's go.",
"8x9 is 72. Let's go, go, go, go, go.",
"8x10 is 80. Let's go.",
"8x11 is 88. Let's go.",
"8x12 is 96. Let's go, go, go, go, go.",

"(Chorus)",
"8 times tables, 8 times tables, 8 times tables.",
"8 times tables, 8 times tables, 8 times tables, go, go, go, go.",

"(Bridge)",
"8, 16, 24, 32, 40, 48, counting by 8’s.",
"56, 64, 72, 80.",
"8, 16, 24, 32, 40, 48, counting by 8’s.",
"56, 64, 72, 80.",

"(Chorus)",
"8 times tables, 8 times tables, 8 times tables.",
"8 times tables, 8 times tables, 8 times tables, go, go, go, go.",
]
  },
  {
    title: "9 Times Table",
    slug: "9timestable",
    standardNumber: "TT",
    description: "Multiplication Facts",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2F9timetablesrock2024video.mp4?alt=media&token=2c7d5f0f-143a-44bb-acfd-ed435452612e",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2F9timestablerock2025song.mp3?alt=media&token=22cb80dc-a409-466a-8b00-08c53d39affd",
    lyrics: ["(Chorus)",
"Let’s make it hot, let’s keep it hot.",
"Let’s hit the spot, 9 times tables.",
"Let’s make it hot, let’s keep it hot.",
"Let’s hit the spot, 9 times tables.",

"(Verse)",
"9x1 is 9; all the time.",
"9x2 is 18; no dream.",
"9x3 is 27; step it up.",
"9x4 is 36; don’t hit bricks.",
"9x5 is 45; keep it live.",
"9x6 is 54; give my all.",
"9x7 is 63; making history.",
"9x8 is 72; what we will do.",
"9x9 is 81; make it fun.",
"9x10 is 90; rewind me.",
"9x11 is 99; right on time.",
"9x12 is 108.",

"(Chorus)",
"Let’s make it hot, let’s keep it hot.",
"Let’s hit the spot, 9 times tables.",
"Let’s make it hot, let’s keep it hot.",
"Let’s hit the spot, 9 times tables.",

"(Bridge)",
"9, 18, 27, 36, 45, 54, 63, 72, 81, 90, 99, 108 (108).",
"9, 18, 27, 36, 45, 54, 63, 72, 81, 90, 99, 108 (108).",

"(Chorus)",
"Let’s make it hot, let’s keep it hot.",
"Let’s hit the spot, 9 times tables.",
"Let’s make it hot, let’s keep it hot.",
"Let’s hit the spot, 9 times tables.",
]
  },
  {
    title: "10 Times Table",
    slug: "10timestable",
    standardNumber: "TT",
    description: "Multiplication Facts",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2F10timetablesrock2025video.mp4?alt=media&token=144184f7-2005-4dd0-8d88-32ebe44c7179",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2F10timestablerock2025song.mp3?alt=media&token=e33d375c-bf62-4411-a2d2-e7f1e33f8f45",
    lyrics: ["(Chorus)",
"10 times any number.",
"You put a zero after that number, you get it.",
"10 times any number.",
"You put a zero after that number, you get it.",

"(Verse 1)",
"10x1 is 10.",
"You put a zero after the 1, you get 10.",
"10x2 is 20.",
"You put a zero after the 2, you get 20.",

"(Bridge 1)",
"10, 20, 30, 40, 50, 60, multiply 10’s, multiply 10’s.",
"70, 80, 90, 100, multiply 10’s, multiply 10’s.",
"10, 20, 30, 40, 50, 60, multiply 10’s, multiply 10’s.",
"70, 80, 90, 100, multiply 10’s, multiply 10’s.",

"(Verse 2)",
"10x4 is 40.",
"You put a zero after the 4, you get 40.",
"10x5 is 50.",
"You put a zero after the 5, you get 50.",

"(Bridge 2)",
"10, 20, 30, 40, 50, 60, multiply 10’s, multiply 10’s.",
"70, 80, 90, 100, multiply 10’s, multiply 10’s.",
"10, 20, 30, 40, 50, 60, multiply 10’s, multiply 10’s.",
"70, 80, 90, 100, multiply 10’s, multiply 10’s.",
]
  },
  {
    title: "11 Times Table",
    slug: "11timestable",
    standardNumber: "TT",
    description: "Multiplication Facts",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2F11timetablesrock2024video.mp4?alt=media&token=02230df3-1f5f-4931-b9b7-1573922c5564",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2F11timestablerock2025song.mp3?alt=media&token=b24d8dbd-a66a-4b7c-86cd-53f511df42be",
    lyrics: ["(Chorus)",
"11, 11 times tables.",
"11, 11 times tables.",
"11, 11 times tables.",
"You know we get it, you know, you know we get it.",

"(Verse)",
"11x1 = 11, do you know it?",
"11x2 = 22, can you show it?",
"11x3 = 33, yes it is.",
"11x4 = 44, work it in.",
"11x5 = 55, keep it going.",
"11x6 = 66, now we’re flowing.",
"11x7 = 77, let it roll.",
"11x8 = 88, keep control.",
"11x9 = 99, again.",
"11x10 = 110.",
"11x11 = 121.",
"11x12 = 132.",

"(Chorus)",
"11, 11 times tables.",
"11, 11 times tables.",
"11, 11 times tables.",
"You know we get it, you know, you know we get it.",
"11, 11 times tables.",
"11, 11 times tables.",
"11, 11 times tables.",
"You know we get it, you know, you know we get it.",

"(Bridge)",
"11, 22, 33, 44, 55, 66, 77, 88, 99, 110, 121, 132.",
"11, 22, 33, 44, 55, 66, 77, 88, 99, 110, 121, 132.",

"(Chorus)",
"11, 11 times tables.",
"11, 11 times tables.",
"11, 11 times tables.",
"You know we get it, you know, you know we get it.",
]
  },
  {
    title: "12 Times Table",
    slug: "12timestable",
    standardNumber: "TT",
    description: "Multiplication Facts",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2F12timetablesrock2024video.mp4?alt=media&token=fdeb76c9-4f04-4a59-a9c5-97fe08281e8c",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2F12timestablerock2025song.mp3?alt=media&token=9de03dd3-3ca1-4971-8708-c4f143e11383",
    lyrics: ["(Chorus)",
"You can love it or hate it, it doesn’t matter, 12 times tables will be there.",
"Songs of higher learning, making it better, 12 times tables will be there.",
"You can love it or hate it, it doesn’t matter, 12 times tables will be there.",
"Songs of higher learning, making it better, 12 times tables will be there.",

"(Verse)",
"12x1 = 12.",
"12x2 = 24.",
"12x3 = 36.",
"12x4 = 48.",
"12x5 = 60.",
"12x6 = 72.",
"12x7 = 84.",
"12x8 = 96.",
"12x9 = 108.",
"12x10 = 120.",
"12x11 = 132.",
"12x12 = 144.",

"(Chorus)",
"You can love it or hate it, it doesn’t matter, 12 times tables will be there.",
"Songs of higher learning, making it better, 12 times tables will be there.",
"You can love it or hate it, it doesn’t matter, 12 times tables will be there.",
"Songs of higher learning, making it better, 12 times tables will be there.",

"(Bridge)",
"12, 24, 36, 48, 60, 72, 84, 96, 108, 120, 132, 144.",
"12, 24, 36, 48, 60, 72, 84, 96, 108, 120, 132, 144.",

"(Chorus)",
"You can love it or hate it, it doesn’t matter, 12 times tables will be there.",
"Songs of higher learning, making it better, 12 times tables will be there.",
"You can love it or hate it, it doesn’t matter, 12 times tables will be there.",
"Songs of higher learning, making it better, 12 times tables will be there.",
]
  }
  
];
export default topics;